module.exports = __webpack_public_path__ + "static/endtoend-02357effc9537747c6b9bae967d418e5.png";